let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1C4CZ")).then(() => parcelRequire('bPqNV'));